import React from 'react'
import useOpenTeam from '../hooks/useOpenTeam'

/**
 * Бейдж банды перед ником игрока: `[Название]` — кликабелен, ведёт на карточку
 * банды `/teams/:slug` (GET /api/team/{slug}/), а не на профиль игрока.
 *
 * Принимает блок `team` из ответа API (в кейсбатлах он называется `user_team`).
 * `team === null` — человек ни в одной банде не состоит: бейджа нет вовсе,
 * никаких «без банды». Аватар банды намеренно не выводится — только название.
 *
 * По умолчанию цвет задаёт токен `team-accent` (tailwind.config.js +
 * `--team-accent` в index.css). Проп `color` нужен только для контекста, где
 * бейдж наследует акцент сущности — например, в hero публичного профиля.
 *
 * Рендерится <span>, а не <button>: бейдж почти всегда лежит внутри ProfileLink
 * или кликабельной карточки, а вложенные интерактивные элементы запрещены HTML.
 * Клик по бейджу не всплывает (см. useOpenTeam) — из одной строки ведут два
 * разных перехода.
 *
 * По умолчанию название показывается целиком (до 24 графем, эмодзи допустимы):
 * ограничения ширины нет, обрезать нормальное название бессмысленно. Сузить
 * можно только точечно, через className в узких строках (`max-w-[5rem]`) —
 * тогда работает CSS `truncate` (не `slice`, иначе эмодзи режется пополам).
 */
const TeamTag = ({ team, className = '', color }) => {
  const openTeam = useOpenTeam()

  if (!team?.name) return null

  return (
    <span
      onClick={team.slug ? (event) => openTeam(event, team.slug) : undefined}
      className={`inline-block truncate align-bottom mr-1 text-team-accent ${
        team.slug ? 'cursor-pointer transition-transform active:scale-[0.98]' : ''
      } ${className}`}
      style={color ? { color } : undefined}
      title={team.name}
    >
      {team.name}
    </span>
  )
}

export default TeamTag
